export default __webpack_public_path__ + "static/media/cautaredosare2.91e962bb.png";